import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { productType } from '../../types';
import { getProductType } from '../../utils/ProductTypes';

HeaderProduct.propTypes = {
    product: productType,
    activeProductType: PropTypes.string,
    classNamePrefix: PropTypes.string
};

function HeaderProduct(props) {
    const {
        product,
        activeProductType = null,
        classNamePrefix = 'auction-header'
    } = props;
    const { t } = useTranslation();

    if (!product) {
        return null;
    }

    return (
        <>
            <div className={`${classNamePrefix}--product`}>
                {product.productId}
                {product.iconSymbol && (
                    <>
                        &nbsp;
                        <FontAwesomeIcon icon={product.iconSymbol} style={{ color: product.iconColor }} className={`${classNamePrefix}--product--icon`} />
                    </>
                )}
            </div>
            {activeProductType === 'ALL' && (
                <div className={`${classNamePrefix}--product-type`}>
                    {getProductType(product.productType).translate(t)}
                </div>
            )}
        </>
    );
}

export default HeaderProduct;
